import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Contact from "../components/Contact";
import Navigation from "../components/Navigation";
import Ordertable from "../components/Ordertable";
import useTitle from "@nooks/use-title";
import { collection, query, onSnapshot } from "firebase/firestore";
import { dbService } from "fbase";
import { doc } from "firebase/firestore";

function Order({userObj, isLoggedIn}){
    const { productid } = useParams();
    const productTextRef = doc(dbService, "productlist", `${productid}`)
    const [product, setProduct] =useState({});
    const [productlist, setProductlist] = useState([]);    const getProduct = useCallback(() => {
        const q = query(collection(dbService, "productlist"));
        onSnapshot(q, (snapshot) => {
            const productArr = snapshot.docs.map((doc) => ({
                fbid: doc.id,
                ...doc.data()
            }));
            setProductlist(productArr);
            productlist.map((product => product.fbid === productid ? setProduct(product) : null))
        })
    }, [productid, productlist])
    useEffect(() => {
        getProduct();
    }, [getProduct]);
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    useTitle("캐리빌리_캐리어 주문하기")
    return (
        <div>
            <Navigation userObj={userObj} isLoggedIn={isLoggedIn} />
            <Ordertable product={product} userObj={userObj} isLoggedIn={isLoggedIn} />
            <Contact />
        </div>
    )
}

export default Order;